<template>
  <div class="about">
    <div class="nav">
      <div class="container flex">
        <div
          class="navItem"
          @click="navChange(item)"
          :class="{active:select==item.id}"
          v-for="item in navbar"
          :key="item.id"
        >{{item.name}}</div>
      </div>
    </div>
    <div class="banner">
      <img
        src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/banner@2x.png"
        alt
      />
    </div>
    <section class="nav1" v-if="select==1">
      <div class="container">
        <h1>「 企业简介 」</h1>
        <img
          src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/fzlc@2x.png"
          alt
        />
        <p>武汉智鼎云网络科技有限公司（Wuhan Zhiding Cloud Technology Co.,Ltd.）是一家专业为企业提供商办物业租售管理及配套服务的互联网企业，公司将以商办物业租售业务为切入点，打造出一个满足用户办公需求的商用资产租售全产业链服务平台。公司于2019年成立于武汉光谷，创始团队主要成员来自于IBM、Apple等知名企业，拥有多年的云计算和大数据系统的软件开发、项目运作和公司管理的经验。目前，武汉智鼎云网络科技有限公司持有及运营的商办物业近30万平方米，并拥有近百万平方米商办物业储备量，预计到2020年持有或运营的商办物业将超过100万平方米。</p>
        <p>武汉智鼎云网络科技有限公司以最新云智能、大数据、移动互联技术，打通WEB、手机APP、微信三个平台，打造出了“智鼎云管家”、“智鼎云找房”和”智鼎云商城”三大行业级技术服务平台。以最先进技术手段为商办楼宇资产全新赋能，实现楼宇资产现在使用价值和未来发展价值的增值，创造出更极致美好的商办楼宇资产增值管理体验。同时，智鼎云平台还提供租售后的一站式企业服务、产业园托管运营、资产管理以及企业金融服务，形成商办领域的生态闭环。</p>
        <p>武汉智鼎云网络科技有限公司将致力于成为商办楼宇资产运营最卓越企业。公司以创新思维改变商办行业传统管理方式，为各大商业地产企业、商办地产运营商及国内外各行各业的公司提供最优越的办公空间项目运营及管理服务。面向未来，智鼎云平台以“推动办公楼宇租赁市场升级，打造一流租赁管理服务平台”为己任，建立更好的更合理的租房市场新秩序，打造“一站式”办公租房新体验。同时，智鼎云的数据资源和平台优势，将有效形成商办领域的生态闭环，为存量时代的物业资产管理运营提供有力支撑，帮助更多的楼宇实现智能化管理，成就互联网+智能最优办公享受！</p>
      </div>
    </section>
    <section class="nav2" v-if="select==2">
      <div class="container">
        <h1>「 核心团队 」</h1>
        <div class="spaceBetween">
          <div class="card" v-for="item in group">
            <div class="avatar">
              <img
                :src="item.img"
                alt
              />
            </div>
            <div class="person flexCenter">
              <p>{{item.name}}</p>
              <p>|</p>
              <p>{{item.role}}</p>
            </div>
            <div class="education">
              <p>{{item.education}}</p>
              <p v-if="item.edu2">{{item.edu2}}</p>
            </div>
            <p class="intro" v-html="item.text"></p>
          </div>
        </div>
      </div>
    </section>
    <section class="nav3" v-if="select==3">
      <div class="container">
        <h1>「 发展历程 」</h1>
        <img class="back" src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/fzlc@2x.png" alt/>
        <div class="time">
          <div class="flex">
            <div class="left">
              <img
                src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/dinwei@2x.png"
                alt
              />
              <div class="timeline"></div>
            </div>
            <div class="right">
              <h3>2018年</h3>
              <div class="timeItem">
                <div class="circle"></div>
                <div class="clock">年底</div>
                <p>凭借着在商办楼宇行业多年的代运营以及互联网监控管理平台开发经验，智鼎云创始人汤志谦开始组建拥有多年云计算和大数据系统的软件开发、项目运作和公司管理的经验的创始团队，致力于通过云智能、大数据、物联网、移动互联等技术手段，打造出一个满足商用资产租售全产业链服务的智慧运营管理平台。</p>
              </div>
              <h3>2019年</h3>
              <div class="timeItem">
                <div class="circle"></div>
                <div class="clock">3月</div>
                <p>武汉智鼎云网络科技有限公司（Wuhan Zhiding Cloud Technology Co.,Ltd.）在武汉光谷正式成立，智鼎云平台项目开发全面启动，公司以“推动办公楼宇租赁市场升级，打造一流租赁管理服务平台”为己任，建立更好的更合理的租房市场新秩序，打造“一站式”办公租房新体验，致力于成为商办楼宇资产运营的卓越企业。</p>
              </div>
              <div class="timeItem">
                <div class="circle"></div>
                <div class="clock">3月至4月</div>
                <p>智鼎云旗下装饰工程公司、物业管理公司、商贸公司等相关配套服务公司相继组建。</p>
              </div>
              <div class="timeItem">
                <div class="circle"></div>
                <div class="clock">6月</div>
                <p>智鼎云管理平台1.0版本正式上线。</p>
              </div>
               <div class="timeItem">
                <div class="circle"></div>
                <div class="clock">7月</div>
                <p>智鼎云与武汉光谷创业街海达创新广场商办综合体签订代运营合作协议，并将此项目打造为智慧园区管理的样板工程，全力推进智鼎云智慧商办楼宇运营管理平台的试点工作。</p>
              </div>
              <div class="timeItem">
                <div class="circle"></div>
                <div class="clock">8月</div>
                <p>智鼎云管理平台1.0版本、房东端和租户端H5及APP1.0版本全面上线。</p>
              </div>
              <div class="timeItem">
                <div class="circle"></div>
                <div class="clock">8月至10月</div>
                <p>智鼎云与武汉光谷金融港、光谷软件园、光谷创业街、汉街、徐东等区域近20万平方米写字楼签订代运营框架合作协议，公司持有及运营的商办物业近30万平方米，并拥有近百万平方米商办物业储备量，预计到2020年持有或运营的商办物业将超过100万平方米。</p>
              </div> 
              <!-- <div class="timeItem">
                <div class="circle"></div>
                <div class="clock">6月20日</div>
                <p>智鼎云集团正式成立。</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="nav4" v-if="select==4">
      <div class="container">
        <h1>「 资质及荣誉 」</h1>
        <div class="award spaceBetween">
          <div class="awardItem" v-for="item,index in award" :key="index">
            <img :src="item.img" alt oncontextmenu="return false;" ondragstart="return false;"/>
            <!-- <h3>{{item.time}}</h3> -->
            <div class="line"></div>
            <p>{{item.text}}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="nav5" v-if="select==5">
      <div class="top">
        <div class="container">
          <h1>「 加入我们 」</h1>
          <div class="job">
            <div class="jobItem">
              <h2>JAVA开发工程师</h2>
              <div class="line"></div>
              <h3>职位要求</h3>
              <ul>
                <li>本科以上学历，具有丰富Java/API开发经验，熟悉软件开发流程，理解面向对象编程思想，熟悉常用的设计模式；</li>
                <li>扎实的java基础，熟练使用spring相关技术，熟悉mybatis、hibernate等持久层框架；</li>
                <li>熟练使用前端语言HTML Css,JS, JQuery, VveJs 等;</li>
                <li>熟练使用maven,git或svn等工具，熟悉tomcat，weblogic;</li>
                <li>熟练使用oracle、mysql等数据库技术、熟悉阿里云或腾讯云平台部署;</li>
                <li>具有公寓、写字楼、房屋租赁服务等项目开发经验优先考虑；</li>
                <li>有Android 、IOS开发，微信公众号开发，小程序开发经验优先考虑；</li>
                <li>善于思考，善于沟通，主动性强，有责任心，具有良好的分析和独立解决问题的能力，能承受极强的工作压力。</li>
              </ul>
            </div>
            <div class="jobItem">
              <h2>Web前端开发工程师</h2>
              <div class="line"></div>
              <h3>职位要求</h3>
              <ul>
                <li>本科学历3年及以上web前端/API开发工作经验，具备公寓、写字楼、房屋租赁服务软件前端开发经验优先；</li>
                <li>精通W3C 标准、HTML、Css.JavaScript、AJAX、 JSON、 XML 等技术;</li>
                <li>熟悉HTML5.熟悉前端界面动态特放的CSS编写，理解用户交互设计，用户体验知识;</li>
                <li>熟悉主流框架、类库的设计和实现，熟练掌握一个前端框架（VveJS.ReactJS、AngularJS) 了解其原理 ;</li>
                <li>有跨浏览器开发经验，理解不同浏览器之间的差异，写出代码具有良好的兼容性;</li>
                <li>有移动互联网的前台开发，爱好WEB编程，具备良好的服务意识、责任心、较强的学习能力、优秀的团队沟通与协作能力;</li>
              </ul>
            </div>
            <div class="jobItem">
              <h2>软件测试工程师</h2>
              <div class="line"></div>
              <h3>职位要求</h3>
              <ul>
                <li>要求具备2年以上软件项目测试经验；</li>
                <li>负责测试环境的搭建，根据测试用例进行测试，并完成测试报告;</li>
                <li>熟悉软件工程以及产品开发过程，有良好的沟通能力和协作精神;</li>
                <li>具备公寓、写字楼、房屋租赁服务软件项目测试、开发经验优先;</li>
                <li>熟悉Web/Java/PHP开发,具有Web前端开发经验优先;</li>
                <li>熟悉cypress UI 和Postan自动化测试工具优先;</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <h1>「 联系方式 」</h1>
        <div class="contain">
          <div class="left">
            <div class="link">
              <img
                src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/1.png"
                alt
              />
              <p>联系电话：4000-989-222</p>
            </div>
            <div class="link">
              <img
                src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/2.png"
                alt
              />

              <p>电子邮箱：hr@zhidingcloud.com</p>
            </div>
            <div class="link">
              <img
                src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/3.png"
                alt
              />

              <p>公司地址：武汉东湖新技术开发区光谷创业街66-6号海达创新广场13楼</p>
            </div>
          </div>
          <div class="right">
            <el-amap vid="amapDemo" :center="markers" :zoom="20" class="amap-demo">
              <el-amap-marker
                :position="markers"
                icon="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/didian@2x.png"
              ></el-amap-marker>
            </el-amap>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      select: "1",
      markers: [114.438603, 30.501167],
      navbar: [
        { name: "关于我们", id: "1" },
        { name: "核心团队", id: "2" },
        { name: "发展历程", id: "3" },
        { name: "资质及荣誉", id: "4" },
        { name: "加入我们", id: "5" }
      ],
      group:[
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/touxiang1.png',name:'汤志谦',role:'CEO创始人',education:'新西兰奥克兰大学电子信息 硕士',text:'\<p\>10年新零售、新能源建筑以及商办写字楼管理经验。\</p\>\<p\>多年商办写字楼项目开发、运营、管理成功经验，目前团队运营商办物业超30万平方米。\</p\>\<p\>覆盖区域包括：光谷步行街、光谷金融港、光谷创业街、总部国际、生物城、软件园等。\</p\>'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/touxiang2.png',name:'胡勤文',role:'CTO联合创始人',education:'新西兰奥克兰大学计算机科学 博士',edu2:'澳门大学智慧城市物联网国家重点实验室  博士后',text:'曾就任多家跨国企业，参与产品设计，研发和安全审计等工作，具备深刻的学术素养，丰富的产品开发经验。主要从事区块链和人工智能平台的开发工作。'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/touxiang3.png',name:'王月',role:'CFO联合创始人',education:'新西兰奥克兰大学经济学 博士',edu2:'香港大学建筑学院城市规划与设计  博士后',text:'具有丰富的国际工作经 ，优秀的沟通能力和领导能力，多次参与高水平国际会议。'},
        {img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/touxiang4.png',name:'杨文涛',role:'首席技术顾问',education:'华中科技大学电子科学系 博士',text:'主要从事计算机信息管理系统与嵌入式系统开发，研究方向为数字图像处理、深度学习和区块链等技术，主持与参与了多项汽车辅助驾驶系统与汽车传感器项目研究、数字电视技术应用，具有丰富产学研经验。'},
      ],
      award:[
        { time: "2019 年 9 月",text:'获得智鼎云安卓端软件著作权',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/card1.png' },
        { time: "2019 年 9 月",text:'获得智鼎云租户端软件著作权',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/card2.png' },
        { time: "2019 年 9 月",text:'获得智鼎云大数据管理平台软件著作权',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/card3.png' },
        { time: "2019 年 9 月",text:'获得智鼎云IOS版软件著作权',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/card4.png' },
        // { time: "2019年3月",text:'荣获2018年武汉市最具价值的企业',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/qiye@2x.png' },
        // { time: "2019年6月",text:'荣获武汉市十佳企业',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/qiye@2x.png' },
        // { time: "2019年1月",text:'荣获武汉市十佳企业',img:'https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/qiye@2x.png' },
      ]
    };
  },
  methods: {
    init() {},
    navChange(val) {
      this.select = val.id;
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang='less' scoped>
@import "~style/index";
.amap-demo {
  height: 430px;
  /deep/ .amap-icon img {
    //改变中心点图标大小
    width: 70px;
    object-fit: contain;
  }
}
.about {
  h1 {
    font-size: 34px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin: 0px 0 60px;
    text-align: center;
  }
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
}

.nav {
  width: 100%;
  background: #2c2d41;
  .navItem {
    color: white;
    line-height: 50px;
    height: 50px;
    flex: 0 0 15%;
    cursor: pointer;
  }
  .navItem.active {
    color: #ff7a32;
  }
}
.nav1 {
  padding-top: 80px;
  img {
    margin-bottom: 50px;
  }
  p {
    font-size: 18px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 60px;
    line-height: 40px;
    text-indent: 2em;
  }
}
.nav2 {
  background: url("https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/beijin@2x.png")
    no-repeat left top;
  background-size: 100% 100%;
  padding: 80px;
  .spaceBetween {
    padding-top: 40px;
  }
  .card {
    flex: 0 0 22%;
    background: #424354;
    position: relative;
    padding: 60px 20px 50px;
    box-sizing: border-box;
    .avatar {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -100%);
      width: 50%;
    }
    .person{

    }
    .flexCenter {
      p {
        color: rgba(255, 255, 255, 1);
      }
      p:first-child {
        font-size: 24px;
        font-weight: bold;
      }
      p:nth-of-type(2) {
        margin: 0px 6px;
      }
      p:last-child {
        font-size: 16px;
        font-weight: 400;
      }
    }
    .education{
      margin-bottom:10px;
      p{
        font-size:14px;
        font-weight:400;
        color:white;
      }
    }
    .intro {
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-indent: 2em;
      p{
        text-indent: 2em;

      }
    }
  }
}
.nav3 {
  padding: 80px;
  .back{
    margin:20px 0;
    width: 100%;
  }
  .time {
    .left {
      width: 80px;
      margin-right: 20px;
      min-height: 100%;
      position: relative;
      img {
        width: 34px;
        display: block;
      }
      .timeline {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        background: #ff7a32;
        height: 95%;
        width: 2px;
      }
    }
    .right {
      img {
        margin-left: 39px;
        width: 90%;
        margin-top:10px;
      }
      .timeItem {
        display: flex;
        align-items: flex-start;
        margin: 10px 0;
        margin-bottom:40px;
        .circle {
          width: 8px;
          min-width: 8px;
          margin-top:15px;
          height: 8px;
          background: #ff7a32;
          border-radius: 50%;
          margin-right: 31px;
        }
        .clock {
          font-size: 20px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-right: 10px;
          min-width:100px;
          height:40px;
          line-height: 40px;
        }
        p {
          font-size: 18px;
          font-weight: 400;
          line-height: 40px;
          color: rgba(102, 102, 102, 1);
        }
      }
    }
  }
}
.nav4 {
  background: url("https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/beijingy@2x.png")
    no-repeat left top;
  background-size: 100% 100%;
  padding: 80px;
  .award {
    flex-wrap: wrap;
    // align-items: center;
    width: 100%;
    .awardItem {
      flex: 0 0 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 30px 0;
      img {
        width: 80%;
      }
      h3 {
        font-size: 24px;
        margin-top: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .line {
        width: 40px;
        height: 2px;
        background: #ff7a32;
        margin: 20px 0;
      }
      p {
        width: 60%;
      }
    }
  }
}
.nav5 {
  .top {
    padding: 80px 0;
    background: url("https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/third/beijingy@2x.png")
      no-repeat left top;
    background-size: 100% 100%;
    .job {
      .jobItem {
        margin-bottom: 50px;
        h2 {
          font-size: 24px;
          font-weight: 400;
          color: rgba(255, 122, 50, 1);
        }
        .line {
          width: 100%;
          height: 2px;
          background: rgba(255, 122, 50, 1);
          margin: 20px 0;
        }
        h3 {
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 20px;
        }
        ul {
          li {
            font-size: 18px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
          }
          li::before {
            display: inline-block;
            content: "";
            width: 5px;
            height: 5px;
            background: black;
            border-radius: 50%;
            margin-right: 10px;
            vertical-align: middle;
          }
        }
      }
      .jobItem:last-child {
        margin-bottom: 20px;
      }
    }
  }
  .bottom {
    padding-top: 80px;
    .contain {
      display: flex;
      align-items: center;
      height: 100%;
    }
    .left {
      padding-right: 20px;
      flex: 1;
      height: 430px;
      background: #2c2d41;
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      justify-content: center;
      .link {
        width: 60%;
        margin-bottom: 20px;
        display: flex;
        img {
          width: 20px;
          height: 32px;
          margin-right: 20px;
        }
        p {
          font-size: 20px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .right {
      flex: 1;
    }
  }
}
</style>